/**
 * Gründio logo & wordmark.
 *  - <ShieldMark /> : compact SVG shield with check + arrow, gradient-filled.
 *  - <Logo />      : wordmark "Gründio" with gradient text + optional ShieldMark prefix.
 */

export const ShieldMark = ({ size = 28, className = "" }) => (
  <span
    className={`logo-mark ${className}`}
    style={{ width: size, height: size, display: "inline-block", position: "relative" }}
  >
    <img
      src="/gruendio-logo.png"
      width={size}
      height={size}
      alt="Gründio"
      className="logo-mark-founder"
      style={{ objectFit: "contain", display: "block", width: size, height: size }}
    />
    <img
      src="/gruendio-logo-business.png"
      width={size}
      height={size}
      alt="Gründio"
      className="logo-mark-business"
      style={{ objectFit: "contain", display: "none", width: size, height: size }}
    />
  </span>
);

export const Logo = ({ size = "md", showMark = true, className = "", variant = "founder" }) => {
  const sizes = {
    sm: { text: "text-base", mark: 22, gap: "gap-2" },
    md: { text: "text-lg sm:text-xl", mark: 28, gap: "gap-2.5" },
    lg: { text: "text-2xl sm:text-3xl", mark: 38, gap: "gap-3" },
    xl: { text: "text-4xl sm:text-5xl", mark: 56, gap: "gap-4" },
  };
  const s = sizes[size] || sizes.md;
  const themeClass = variant === "business" ? "theme-petrol" : "";
  return (
    <div className={`flex items-center ${s.gap} ${themeClass} ${className}`} data-testid="brand-logo">
      {showMark && <ShieldMark size={s.mark} />}
      <span
        className={`${s.text} font-extrabold tracking-tight brand-gradient-text`}
        style={{ fontFamily: "Outfit, sans-serif" }}
      >
        Gründio
      </span>
    </div>
  );
};

export default Logo;
